<template>
    <div class="content">
      <div class="container-fluid">
         <div class="row">
          <b-modal
              id="modal-top-add"
              hide-footer
              title="Add Users"
              content-class="shadow"
            >
              <template #modal-header="{ close }">
                <h5>{{ translate('addUsers') }}</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
              </template>
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form
                  class="text-left"
                  @submit.stop.prevent="handleSubmit(submitAddForm)"
                >
                  <b-row no-gutters>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="addData.firstName"
                        @update:modelValue="
                          (newValue) => (addData.firstName = newValue)
                        "
                        :rules="{ required: true, min: 3 , max: 20, regex:/^[a-zA-Z]+$/}"
                        id="text-firstName"
                        name="text-firstName"
                        :label="translate('firstName')"
                        class="mb-1 mr-sm-2"
                        description="text-firstName-feedback"
                        validatorName="First Name"
                      />
                    </b-col>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="addData.lastName"
                        @update:modelValue="
                          (newValue) => (addData.lastName = newValue)
                        "
                        :rules="{ required: true, min: 3 , max: 20, regex:/^[a-zA-Z]+$/ }"
                        id="text-lastName"
                        name="text-lastName"
                        :label="translate('lastName')"
                        class="mb-1 mr-sm-2"
                        description="text-lastName-feedback"
                        validatorName="Last Name"
                      />
                    </b-col>
                    <b-col md="12" style="justify-content: center; align-items: center">
    <Vinput
      inputType="text"
      :modelValue="addData.username"
      @update:modelValue="(newValue) => {
        // Check for special characters, spaces, and update the model value
        const sanitizedValue = newValue.replace(/[^a-zA-Z0-9\s]/g, ''); // Allow spaces
        addData.username = sanitizedValue.slice(0, 15); // Limiting to 15 characters
      }"
      :rules="{ required: true, min: 3, max: 15 }"
      id="text-userName"
      name="text-userName"
      :label="translate('username')"
      class="mb-1 mr-sm-2"
      description="text-userName-feedback"
      validatorName="Username"
    />
  </b-col>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <VinputGroup
                        inputType="text"
                        :modelValue="addData.phoneNumber"
                        @update:modelValue="
                          (newValue) => (addData.phoneNumber = newValue)
                        "
                        :rules="{ required: true, regex:/^\d{9}$/ }"
                        id="text-phoneNumber"
                        name="text-phoneNumber"
                        :label="translate('phoneNumber')"
                        class="mb-1 mr-sm-2"
                        description="text-phoneNumber-feedback"
                        validatorName="Phone Number"
                        prepend="+251"
                      />
                    </b-col>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="addData.email"
                        @update:modelValue="
                          (newValue) => (addData.email = newValue)
                        "
                        :rules="{ regex:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/ }"
                        id="text-email"
                        name="text-email"
                        :label="translate('email')"
                        class="mb-1 mr-sm-2"
                        description="text-email-feedback"
                        validatorName="Email"
                      />
                    </b-col>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                       <Vselect
                        :modelValue="addData.role"
                        @update:modelValue="
                          (newValue) => (addData.role = newValue)
                        "
                        :options="roleOptions"
                        :rules="{ required: true }"
                        id="text-role"
                        name="text-role"
                        :label="translate('role')"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-role-feedback"
                        validatorName="Role"
                      />
                    </b-col>
                    <b-col  
                    v-if="addData.role === 'SUPER_ADMIN'"
                    md="12" style="justify-content: center; align-items: center">
                        <Vinput
                          :modelValue="addData.accountNumber"
                          @update:modelValue="(newValue) => { addData.accountNumber = newValue }"
                          :rules="{ required: true }"
                          id="text-accountNumber"
                          name="text-accountNumber"
                          :label="translate('accountNumber')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubType-feedback"
                          validatorName="Account Number"
                        />
                      </b-col>
                    <b-col  
                    <b-col class="mt-2">
                      <b-button type="submit" variant="primary">{{translate('submit')}}</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
          </b-modal>
        </div>
        <div class="row">
          <b-modal
              id="modal-top-EditUsers"
              hide-footer
              title="Edit Users"
              content-class="shadow"
            >
              <template #modal-header="{ close }">
                <h5>{{ translate('editUser') }}</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
              </template>
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form
                  class="text-left"
                  @submit.stop.prevent="handleSubmit(submitEditForm)"
                >
                <b-row no-gutters>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="selectedUsers.firstName"
                        @update:modelValue="
                          (newValue) => (selectedUsers.firstName = newValue)
                        "
                        :rules="{ required: true, min: 3, regex:/^[a-zA-Z]+$/}"
                        id="text-firstName"
                        name="text-firstName"
                        :label="translate('firstName')"
                        class="mb-1 mr-sm-2"
                        description="text-firstName-feedback"
                        validatorName="First Name"
                      />
  
                    </b-col>
  
                     <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                      <Vinput
  
                        inputType="text"
  
                        :modelValue="selectedUsers.lastName"
  
                        @update:modelValue="
  
                          (newValue) => (selectedUsers.lastName = newValue)
  
                        "
  
                        :rules="{ required: true, min: 3, regex:/^[a-zA-Z]+$/ }"
  
                        id="text-lastName"
  
                        name="text-lastName"
  
                        :label="translate('lastName')"
  
                        class="mb-1 mr-sm-2"
  
                        description="text-lastName-feedback"
  
                        validatorName="Last Name"
  
                      />
  
                    </b-col>
  
                    <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                      <Vinput
  
                        inputType="text"
  
                        :modelValue="selectedUsers.username" 
  
                        @update:modelValue="
  
                          (newValue) => (selectedUsers.username = newValue)
  
                        "
  
                        :rules="{ required: true, min: 3 }"
  
                        id="text-userName"
  
                        name="text-userName"
  
                        :label="translate('username')"
  
                        class="mb-1 mr-sm-2"
  
                        description="text-userName-feedback"
  
                        validatorName="Username"
  
                        disabled="disabled"
  
                      />
  
                    </b-col>
  
                    <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                      <VinputGroup
  
                        inputType="text"
  
                        :modelValue="selectedUsers.phoneNumber"
  
                        @update:modelValue="
  
                          (newValue) => (selectedUsers.phoneNumber = newValue)
  
                        "
  
                        :rules="{ required: true, regex:/^\d{9}$/ }"
  
                        id="text-phoneNumber"
  
                        name="text-phoneNumber"
  
                        :label="translate('phoneNumber')"
  
                        class="mb-1 mr-sm-2"
  
                        description="text-phoneNumber-feedback"
  
                        validatorName="Phone Number"
  
                        prepend="+251"
  
                      />
  
                    </b-col>
  
                    <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                      <Vinput
  
                        inputType="text"
  
                        :modelValue="selectedUsers.email"
  
                        @update:modelValue="
  
                          (newValue) => (selectedUsers.email = newValue)
  
                        "
  
                        :rules="{ regex:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/ }"
  
                        id="text-email"
  
                        name="text-email"
  
                        :label="translate('email')"
  
                        class="mb-1 mr-sm-2"
  
                        description="text-email-feedback"
  
                        validatorName="Email"
  
                      />
  
                    </b-col>
  
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                       <Vselect
                        :modelValue="selectedUsers.role"
                        @update:modelValue="
                          (newValue) => (selectedUsers.role = newValue)
                        "
                        :options="roleOptions"
                        :rules="{ required: true }"
                        id="text-role"
                        name="text-role"
                        :label="translate('role')"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-role-feedback"
                        validatorName="Role"
                      />
                    </b-col>
                    <b-col class="mt-2">
                      <b-button type="submit" variant="primary">{{translate('submit')}}</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-modal>
        </div>
         <div class="row">
          <b-modal
              id="modal-top-EditUsersPermission"
              hide-footer
              title="Edit Users Permission"
              content-class="shadow"
              size="lg"
            >
              <template #modal-header="{ close }">
                <h5>{{ translate('usersPermissions') }}</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
              </template>
              <b-row>
              <b-col lg="8" class="my-1">
                  <b-button v-if="modulePermission.update == 1" @click="AddPermission(ID)" class="btn-outline-primary">
                    <b-icon class="text-center" icon="plus"></b-icon> {{ translate('addModule') }}
                  </b-button>
                </b-col>
              </b-row>
              <b-table-simple
                :small="true"
                sticky-header
                style="max-height: 395px;"
                striped
                responsive="md"
                hover
              >
                <b-thead>
                  <b-tr>
                    <b-th>{{ translate('no') }}</b-th>
                    <b-th>{{ translate('module') }}</b-th>
                    <b-th>{{ translate('view') }}</b-th>
                    <b-th>{{ translate('create') }}</b-th>
                    <b-th>{{ translate('update') }}</b-th>
                    <b-th>{{ translate('delete') }}</b-th>
                    <b-th sticky-column style="height: 45px;"></b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <template>
                  <b-tr
                    v-for="(item, index) in modulePermissionList"
                    :key="item.ID"
                  >
                      <b-td>{{++index}}</b-td>
                      <b-td>{{item.name}}</b-td>
                      <b-td v-if="item.listData == 1"><b-icon icon="check-lg" style="color: rgb(37, 91, 48)"></b-icon></b-td>
                      <b-td v-else><b-icon icon="x-lg" style="color: rgb(251, 64, 75)"></b-icon></b-td>
                      <b-td v-if="item.createData == 1"><b-icon icon="check-lg" style="color: rgb(37, 91, 48)"></b-icon></b-td>
                      <b-td v-else><b-icon icon="x-lg" style="color: rgb(251, 64, 75)"></b-icon></b-td>
                      <b-td v-if="item.updateData == 1"><b-icon icon="check-lg" style="color: rgb(37, 91, 48)"></b-icon></b-td>
                      <b-td v-else><b-icon icon="x-lg" style="color: rgb(251, 64, 75)"></b-icon></b-td>
                      <b-td v-if="item.deleteData == 1"><b-icon icon="check-lg" style="color: rgb(37, 91, 48)"></b-icon></b-td>
                      <b-td v-else><b-icon icon="x-lg" style="color: rgb(251, 64, 75)"></b-icon></b-td>
                      <b-td sticky-column>
                        <b-row style="width: 180px;">
                          <b-col md="6" class="mb-2" v-if="modulePermission.update == 1">
                            <b-badge @click="EditPermission(item.name)" variant="primary">Edit</b-badge>
                          </b-col>
                          <b-col md="6" class="mb-2" v-if="modulePermission.update == 1">
                            <b-badge @click="DeletePermission(item.name)" variant="primary">Delete</b-badge>
                        </b-col>
                        </b-row>
                      </b-td>
                  </b-tr>
                  </template>
                </b-tbody>
              </b-table-simple>
            </b-modal>
        </div>
        <div class="row">
          <b-modal
              id="modal-top-add-permission"
              hide-footer
              title="Add Permission"
              content-class="shadow"
            >
              <template #modal-header="{ close }">
                <h5>{{ translate('addPermission') }}</h5>
  
                <p class="h5 mb-2">
  
                  <b-icon
  
                    icon="x-square"
  
                    class="close-icon"
  
                    @click="
  
                      close();
  
                      clearData();
  
                    "
  
                  ></b-icon>
  
                </p>
  
              </template>
  
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
  
                <b-form
  
                  class="text-left"
  
                  @submit.stop.prevent="handleSubmit(submitAddPermissionForm)"
  
                >
  
                  <b-row no-gutters>
  
                     <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                       <Vselect
  
                        :modelValue="addPermission.moduleName"
  
                        @update:modelValue="
  
                          (newValue) => (addPermission.moduleName = newValue)
  
                        "
  
                        :options="moduleOptions"
  
                        :rules="{ required: true }"
  
                        id="text-module"
  
                        name="text-module"
  
                        :label="translate('module')"
  
                        class="mb-1 mr-sm-2 some-select"
  
                        description="text-module-feedback"
  
                        validatorName="Module"
  
                      />
  
                    </b-col>
  
                    <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                       <b-form-checkbox v-model="addPermission.listData" name="check-button" switch>
  
                            {{translate('view')}}
  
                        </b-form-checkbox>
  
                    </b-col>
  
                     <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                       <b-form-checkbox v-model="addPermission.createData" name="check-button" switch>
  
                        {{translate('create')}}
  
                        </b-form-checkbox>
  
                    </b-col>
  
                    <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                       <b-form-checkbox v-model="addPermission.updateData" name="check-button" switch>
  
                        {{translate('update')}}
  
                        </b-form-checkbox>
  
                    </b-col>
  
                    <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                       <b-form-checkbox v-model="addPermission.deleteData" name="check-button" switch>
  
                        {{translate('delete')}}
  
                        </b-form-checkbox>
  
                    </b-col>
  
                    <b-col class="mt-2">
  
                      <b-button type="submit" variant="primary">Submit</b-button>
  
                    </b-col>
  
                  </b-row>
  
                </b-form>
  
              </validation-observer>
  
          </b-modal>
  
        </div>
  
        <div class="row">
  
          <b-modal
  
              id="modal-top-edit-permission"
  
              hide-footer
  
              title="Edit Permission"
  
              content-class="shadow"
  
            >
  
              <template #modal-header="{ close }">
  
                <h5>Edit Permission</h5>
  
                <p class="h5 mb-2">
  
                  <b-icon
  
                    icon="x-square"
  
                    class="close-icon"
  
                    @click="
  
                      close();
  
                      clearData();
  
                    "
  
                  ></b-icon>
  
                </p>
  
              </template>
  
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
  
                <b-form
  
                  class="text-left"
  
                  @submit.stop.prevent="handleSubmit(submitEditPermissionForm)"
  
                >
  
                  <b-row no-gutters>
  
                     <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                       <Vinput
  
                        :modelValue="addPermission.moduleName"
  
                        @update:modelValue="
  
                          (newValue) => (addPermission.moduleName = newValue)
  
                        "
  
                        :rules="{ required: true }"
  
                        id="text-module"
  
                        name="text-module"
  
                        label="Module"
  
                        class="mb-1 mr-sm-2 some-select"
  
                        description="text-module-feedback"
  
                        validatorName="Module"
  
                        disabled="disabled"
  
                      />
  
                    </b-col>
  
                    <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                       <b-form-checkbox v-model="addPermission.listData" name="check-button" switch>
  
                            View
  
                        </b-form-checkbox>
  
                    </b-col>
  
                     <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                       <b-form-checkbox v-model="addPermission.createData" name="check-button" switch>
  
                            Create
  
                        </b-form-checkbox>
  
                    </b-col>
  
                    <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                       <b-form-checkbox v-model="addPermission.updateData" name="check-button" switch>
  
                            Update
  
                        </b-form-checkbox>
  
                    </b-col>
  
                    <b-col
  
                      md="12"
  
                      style="justify-content: center; align-items: center"
  
                    >
  
                       <b-form-checkbox v-model="addPermission.deleteData" name="check-button" switch>
  
                            Delete
  
                        </b-form-checkbox>
  
                    </b-col>
  
                    <b-col class="mt-2">
  
                      <b-button type="submit" variant="primary">Submit</b-button>
  
                    </b-col>
  
                  </b-row>
  
                </b-form>
  
              </validation-observer>
  
          </b-modal>
  
        </div>
  
        <div class="row mt-3">
  
          <div class="col-12">
  
            <card class="strpied-tabled-with-hover"
  
                  body-classes="table-full-width table-responsive"
  
            >
  
               <template slot="header">
                <b-row>
                <b-col lg="8" class="my-1">
                  <b-button v-if="modulePermission.create == 1" @click="AddUsers()" class="btn-outline-primary">
                    <b-icon class="text-center" icon="plus"></b-icon> {{translate('newUsers')}}
                  </b-button>
                </b-col>
               <b-col lg="4" class="my-1">
                    <b-form-group class="mb-0">
                      <b-input-group size="sm">
                        <b-form-input
                          id="filter-input"
                          v-model="filter"
                          type="search"
                          placeholder="Filter"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                            >Clear</b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </template>
              <div class="table-container">
              <b-table-simple
                :small="true"
                sticky-header
                style="max-height: 395px;"
                striped
                responsive="sm"
                hover
              >
                <b-thead class="sticky-header">
                  <b-tr>
                    <b-th>{{translate('no')}}</b-th>
                    <b-th>{{translate('firstName')}}</b-th>
                    <b-th>{{translate('lastName')}}</b-th>
                    <b-th>{{translate('username')}}</b-th>
                    <b-th>{{translate('email')}}</b-th>
                    <b-th>{{translate('phoneNumber')}}</b-th>
                    <b-th>{{translate('role')}}</b-th>
                    <b-th>{{translate('createdAt')}}</b-th>
                    <b-th sticky-column style="height: 45px;"></b-th>
                  </b-tr>
                </b-thead>
                <template v-if="spinner">
                  <b-tbody class="text-center">
                     <b-tr >
                         <b-td colspan="9" class="text-center" style="display: table-cell">
                          <b-spinner
                          style="height: 3rem; width: 3rem;"
                            variant="warning"
                          ></b-spinner>
                         </b-td>
                      </b-tr>
                  </b-tbody>
                </template>
                <template v-else>
                <b-tbody>
                  <template v-if="filterTable.length === 0">
                      <b-tr>
                        <b-td colspan="8" class="text-center">{{ translate('nothingFound') }}</b-td>
                        <b-td></b-td>
                      </b-tr>
                  </template>
                  <template v-else>
                  <b-tr
                    v-for="(item, index) in filterTable"
                    :key="item.ID"
                  >
                      <b-td>{{++index}}</b-td>
                      <b-td>{{item.firstName}}</b-td>
                      <b-td>{{item.lastName}}</b-td>
                      <b-td>{{item.username}}</b-td>
                      <b-td>{{item.email}}</b-td>
                      <b-td>{{item.phoneNumber}}</b-td>
                      <b-td>{{item.role.name}}</b-td>
                      <b-td>{{item.createdDate}}</b-td>
                      <b-td sticky-column>
                        <b-row>
                            <b-col md="4" class="mb-2" v-if="modulePermission.update == 1 && item.lockStatus == 1">
                              <b-icon icon="unlock-fill" class="btn-icon" :title="translate('lockUser')" @click="LockUser(item.username)" aria-hidden="true" ></b-icon>
                            </b-col>
                          <b-col md="4" class="mb-2" v-if="modulePermission.update == 1 && item.lockStatus == 0">
                            <b-icon icon="Lock-fill" class="btn-icon" :title="translate('unlockUser')" @click="UnlockUser(item.username)" aria-hidden="true" ></b-icon>
                          </b-col>
                         <b-col md="4" class="mb-2" v-if="modulePermission.update == 1">
                            <b-icon icon="pencil-square" class="btn-icon" :title="translate('editUser')"  @click="EditUsers(item.id)" aria-hidden="true" ></b-icon>
                          </b-col>
                          <b-col md="4" class="mb-2" v-if="modulePermission.update == 1">
                            <b-icon icon="person-lines-fill" class="btn-icon" :title="translate('usersPermissions')" @click="ViewPermission(item.id)" aria-hidden="true" ></b-icon>
                          </b-col>
                        </b-row>
                      </b-td>
                  </b-tr>
                  </template>
                </b-tbody>
                </template>
              </b-table-simple>
            </div>
            <!-- Pagination outside the table to prevent overlap -->
            <div class="pagination-container">
              <b-row class="mt-3 align-items-center justify-content-between">
                <b-col class="d-flex align-items-center">
                  <label class="mr-2 mb-0">{{ translate('recordsPerPage') }}</label>
                  <b-form-select
                    id="input-horizontal"
                    class="custom-dropdown"
                    v-model="perPage"
                    :options="pageOptions"
                    @change="changePerPage"
                  >
                  </b-form-select>
                </b-col>
                <b-col class="d-flex justify-content-end">
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalRows"
                    @page-click="changePage"
                    align="right"
                  />
                </b-col>
              </b-row>
            </div>
             </card>
  
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import LTable from 'src/components/Table.vue'
    import Card from 'src/components/Cards/Card.vue'
    import Vinput from 'src/components/Inputs/Vinput.vue'
    import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
    import Vselect from 'src/components/Inputs/Vselect.vue'
    import VinputGroup from 'src/components/Inputs/VinputGroup.vue'
    import { setLanguage, translate } from 'src/i18n.js';
    export default {
      components: {
        LTable,
        Card,
        Vinput,
        VinputNumber,
        Vselect,
        VinputGroup
      },
      data () {
        return {
          modulePermission: {
            view: 1,
            create: 0,
            update: 0,
            delete: 0
          },
          totalRows: 0,
          currentPage: 1,
          perPage: 7,
          ekubTypeOptions: [],
          pageOptions: [
            {value: 7, text: 7},
            {value: 10, text: 10},
            {value: 25, text: 25},
            {value: 50, text: 50},
            {value: 100, text: 100}
          ],
          items: [],
          addData: {
              firstName: "",
              lastName : "",
              accountNumber: "",
              email: "",
              username: "",
              phoneNumber: "",
              role: "",
              associationId:null,
              createdBy: sessionStorage.getItem("ID"),
              ownedBy: null
  
          },
          addPermission:{
            moduleName:"",
            listData: true,
            createData: false,
            updateData: false,
            deleteData: false,
          },
  
          selectedUsers: {},
  
          roleOptions:[
          {value: "SYSTEM_MANAGER", text:translate('System Manager')},
          {value: "SUPER_ADMIN", text:translate('Super Admin')},
          ],
          moduleOptions: [],
          filter: "",
          modulePermissionList: [],
          spinner: true
        }
  
      },
  
       mounted() {
        this.getModules();
        this.getEkubsByOwnerID();
        this.getModulesList();
        this.getUsersByOwnerID();
        this.$on("AfterComplete", () => {
          this.getModules();
          this.getModulesList();
          this.getUsersByOwnerID();
          this.getEkubsByOwnerID();
        });
  
      },
  
      computed: {
  
        filterTable() {
  
          var searchItems = this.items;
  
          var searchString = this.filter;
  
          if (searchString === "") {
  
            return searchItems;
  
          }
  
          searchString = searchString.trim().toLowerCase();
  
   
  
          searchItems = searchItems.filter(function (item) {
  
            if (item.username.toLowerCase().indexOf(searchString) !== -1 ||  item.firstName.toLowerCase().indexOf(searchString) !== -1 || item.lastName.toLowerCase().indexOf(searchString) !== -1 || item.phoneNumber.toLowerCase().indexOf(searchString) !== -1 ) {
  
              return item;
  
            }
  
          });
  
          return searchItems;
  
        },
  
      },
  
      methods: {
        translate,
      changeLanguage(lang) {
        setLanguage(lang);
        this.$forceUpdate();
      },
      getEkubTypeName() {
    var ekubName = "";
    var value = this.addData.associationId;
    if (value !== null && value !== "" && value !== 0) {
      const selectedEkub = this.ekubTypeOptions.find(item => item.value == value);
      ekubName = selectedEkub ? selectedEkub.text : "";
    }
    return ekubName;
  },
      restrictCharacters(event) {
  
      const allowedCharacters = /^[a-zA-Z0-9]+$/;
  
      if (!event.key.match(allowedCharacters) && event.key !== ' ') {
  
       event.preventDefault();
  
      }
  
    },
  
        nameValidation(value){
  
          const regex = /^[a-zA-Z]+$/;
  
          return regex.text(value) || 'Only letters are allowed';
  
        },
  
        validateUsername(value) {
  
        const restrictedChars = ["'", '"', ';', '%', '(', ')', '*', '-', '-', '=', '$', ' ', '/'];
  
       
  
        for (let i = 0; i < restrictedChars.length; i++) {
  
          if (value.includes(restrictedChars[i])) {
  
            return 'Invalid character found in the username';
  
          }
  
        }
  
       
  
        return true;
  
      },
  
        getModulesList(){
           this.$store.dispatch('getModulesList')
            .then(response=>{
                Array.from(response.data).forEach((value) => {
                  this.moduleOptions.push({
                    value: value.module,
                    text: value.module
                  });
                });
            })
            .catch(error=>{
                console.log(error);
            })
        },
        getModules(){
          this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
            .then(response=>{
                //this.items = response.data;
                var modulesList = response.data.modules;
                var UserModule = modulesList.filter(x=>x.name === "User_System");
                //console.log("UserModukleList", UserModule);
                if(UserModule !== null){
                  this.modulePermission.view = UserModule[0].listData;
                  this.modulePermission.create = UserModule[0].createData;
                  this.modulePermission.update = UserModule[0].updateData;
                  this.modulePermission.delete = UserModule[0].deleteData;
                }
  
            })
  
            .catch(error=>{
  
                console.log(error);
  
            })
  
        },
  
        numberWithCommas(x) {
  
          if(x !== null && x !== undefined){
  
              x = x.toFixed(2);
  
              return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
          }
  
        },
        getEkubsByOwnerID() {
    this.$store.dispatch('getAllAssociation', { userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")) })
      .then(response => {
        this.ekubTypes = response.data;  // Assuming 'response.data' is the array of ekub objects
        this.ekubTypeOptions = this.ekubTypes.map(ekub => ({
          value: ekub.id,            // 'value' for Vselect
          text: ekub.ekubName,       // 'text' for Vselect
          ekubType: ekub.ekubType,   // The ekubType for potential use
          ekubAmount: ekub.ekubAmount, // Amount for calculated display
          numberOfEkuber: ekub.numberOfEkuber, // Number of members for display
          cycle: ekub.cycle,         // Cycle duration for calculated display
          cycleDuration: ekub.cycleDuration // Cycle duration for calculated display
        }));
      })
      .catch(error => {
        this.$notify({
          title: 'Error',
          text: error.response.data,
          type: 'error'
        });
      });
  },
        getUsersByOwnerID(){
  
          this.spinner = true;
  
            this.$store.dispatch('getUserBySystemAdminId', {userId:  parseInt( sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), currentId:  parseInt( sessionStorage.getItem("userID")), page: this.currentPage, line: this.perPage})
  
            .then(response=>{
  
              //console.log("sdkfh", response.data);
  
                this.items = response.data.Contents.filter(x=>x.id != sessionStorage.getItem("userID"));
  
                this.totalRows = response.data.totalElements;
  
            })
  
            .catch(error=>{
  
                // this.$notify({
  
                //     title: 'Error',
  
                //     text: error.response.data,
  
                //     type: 'error'
  
                // })
  
                console.log(error);
  
            })
  
            .finally(msg=>{
  
              this.spinner =false;
  
            })
  
        },
  
        changePage(event, page){
  
          this.spinner = true;
  
          this.$store.dispatch('getUserBySystemAdminId',{userId:  parseInt( sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), currentId:  parseInt( sessionStorage.getItem("userID")), page: page, line: this.perPage})
  
            .then(response=>{
  
                this.items = response.data.Contents.filter(x=>x.id != sessionStorage.getItem("userID"));
  
                this.totalRows = response.data.totalElements;
  
            })
  
            .catch(error=>{
  
                // this.$notify({
  
                //     title: 'Error',
  
                //     text: error.response.data,
  
                //     type: 'error'
  
                // })
  
                console.log(error);
  
            })
  
            .finally(msg=>{
  
              this.spinner =false;
  
            })
  
        },
  
        changePerPage(event){
  
          this.spinner = true;
  
          this.$store.dispatch('getUserBySystemAdminId', {userId:  parseInt( sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), currentId:  parseInt( sessionStorage.getItem("userID")), page: this.currentPage, line: this.perPage})
  
            .then(response=>{
  
                this.items = response.data.Contents.filter(x=>x.id != sessionStorage.getItem("userID"));
  
                this.totalRows = response.data.totalElements;
  
            })
  
            .catch(error=>{
  
                // this.$notify({
  
                //     title: 'Error',
  
                //     text: error.response.data,
  
                //     type: 'error'
  
                // })
  
                console.log(error);
  
            })
  
            .finally(msg=>{
  
              this.spinner =false;
  
            })
  
        },
  
        AddUsers(){
  
          this.$bvModal.show('modal-top-add');
  
        },
        submitAddForm(){
          this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
               title: translate('confirm'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                cancelVariant: 'danger',
                okTitle:  translate('yes'),
                cancelTitle: translate('nono'),
                bodyClass: 'm-2',
                hideHeaderClose: false,
                centered: false
            })
          .then(value => {
            const userData = {
              firstName: this.addData.firstName,
              lastName: this.addData.lastName,
              accountNumber: this.addData.accountNumber,
              email: this.addData.email,
              username: this.addData.username,
              phoneNumber: "+251" + this.addData.phoneNumber,
              role: this.addData.role,
              createdBy: sessionStorage.getItem("ID"),
              associationId: this.addData.associationId,
              ownedBy: sessionStorage.getItem("userID"),
              superUserId: parseInt(sessionStorage.getItem("superID")),
            };
            const action = this.addData.role === "SUPER_ADMIN" ? 'AddUsersSUperUser' : 'AddUserSystemManager';
              if(value === true){
                this.$store.dispatch(action, userData)
                .then(response=>{
                    this.$notifications.notify(
                      {
                        message: `Users successfully created.`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      }
                    )
                      this.$bvModal.hide('modal-top-add');
                      this.clearData();
                })
                .catch(error=>{
                    this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                })
              }
          })
          .catch(error=>{
              console.log(error)
          })
        },
        EditUsers(ID){
          this.selectedUsers = this.items.filter(item=> item.id == ID)[0];
          this.selectedUsers.role = this.selectedUsers.role.name;
          if(this.selectedUsers.phoneNumber.startsWith("+251")){
            var some = this.selectedUsers.phoneNumber.slice(4,13);
            this.selectedUsers.phoneNumber = some;
          }
          if(this.selectedUsers.phoneNumber.startsWith("09")){
            var some = this.selectedUsers.phoneNumber.slice(2,9);
            this.selectedUsers.phoneNumber = some;
          }
          this.$bvModal.show('modal-top-EditUsers');
        },
        submitEditForm(){
          this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
              title: translate('confirm'),
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle:  translate('yes'),
              cancelTitle: translate('nono'),
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
          .then(value => {
              if(value === true){
                console.log("json",this.selectedUsers);
                this.$store.dispatch('UpdateUser', {
                  id: this.selectedUsers.id,
                  firstName: this.selectedUsers.firstName,
                  lastName : this.selectedUsers.lastName,
                  accountNumber: this.selectedUsers.accountNumber,
                  email: this.selectedUsers.email,
                  phoneNumber: "+251"+this.selectedUsers.phoneNumber,
                  role: this.selectedUsers.role
                })
                .then(response=>{
                  console.log("success ",response.data);
                    this.$notifications.notify(
                      {
                        message: `The Users Successfully Updated.`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      })
                      this.$bvModal.hide('modal-top-EditUsers');
                      this.clearData();
                })
                .catch(error=>{
                  console.log(error);
                  this.$notifications.notify(
                      {
                        message: error.response.data,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'danger'
                      })
                })
              }
          })
          .catch(error=>{
              console.log(error)
          })
        },
        ViewPermission(ID){
          this.$store.dispatch('getModulesPermission', {userId: ID})
          .then(response=>{
            this.selectedUsers = this.items.filter(item=> item.id == ID)[0];
            //console.log("this.selectedUsers :", this.selectedUsers );
            this.modulePermissionList = response.data.modules;
            this.$bvModal.show('modal-top-EditUsersPermission');
          })
          .catch(error=>{
            console.log(error);
          })
        },
        AddPermission(ID){
          this.$bvModal.show('modal-top-add-permission');
        },
        submitAddPermissionForm(){
          this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
                title: translate('confirm'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                cancelVariant: 'danger',
                okTitle:  translate('yes'),
                cancelTitle: translate('nono'),
                bodyClass: 'm-2',
                hideHeaderClose: false,
                centered: false
            })
          .then(value => {
              if(value === true){
                var moduleToAdd  = {
                  userId: this.selectedUsers.id,
                  module: this.addPermission.moduleName,
                  createData: this.addPermission.createData == true ? 1:0,
                  listData: this.addPermission.listData == true ? 1:0,
                  updateData: this.addPermission.updateData == true ? 1:0,
                  deleteData: this.addPermission.deleteData == true ? 1:0
                }
                this.$store.dispatch('AddModuleAndPermission', moduleToAdd)
                .then(response=>{
                    this.$notifications.notify(
                      {
                        message: `Module and Permission Successfully created.`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      })
                   this.$store.dispatch('getModulesPermission', {userId: this.selectedUsers.id})
                    .then(response=>{
                      this.modulePermissionList = response.data.modules;
                    })
                    .catch(error=>{
                      console.log(error);
                    })
                    this.$bvModal.hide('modal-top-add-permission');
                    this.clearData();
                })
                .catch(error=>{
                     this.$notifications.notify(
                      {
                        message: error.response.data,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'danger'
                      })
                })
              }
          })
          .catch(error=>{
              console.log(error)
          })
        },
        EditPermission(name){
          var moduleToEdit = this.modulePermissionList.filter(item=>item.name == name)[0];
          this.addPermission.moduleName = moduleToEdit.name;
          this.addPermission.createData = moduleToEdit.createData == 1? true: false;
          this.addPermission.listData = moduleToEdit.listData == 1? true: false;
          this.addPermission.deleteData = moduleToEdit.deleteData == 1? true: false;
          this.addPermission.updateData = moduleToEdit.updateData == 1? true: false;
          this.$bvModal.show('modal-top-edit-permission');
        },
        submitEditPermissionForm(){
          this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
                title: translate('confirm'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                cancelVariant: 'danger',
                okTitle:  translate('yes'),
                cancelTitle: translate('nono'),
                bodyClass: 'm-2',
                hideHeaderClose: false,
                centered: false
            })
          .then(value => {
              if(value === true){
                var moduleToEdit  = {
                  userId: this.selectedUsers.id,
                  module: this.addPermission.moduleName,
                  createData: this.addPermission.createData == true ? 1:0,
                  listData: this.addPermission.listData == true ? 1:0,
                  updateData: this.addPermission.updateData == true ? 1:0,
                  deleteData: this.addPermission.deleteData == true ? 1:0
                }
                this.$store.dispatch('UpdateModuleAndPermission', moduleToEdit)
                .then(response=>{
                    this.$notifications.notify(
                    {
                        message: `Module and Permission Successfully updated.`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      }
                    )
                   this.$store.dispatch('getModulesPermission', {userId: this.selectedUsers.id})
                    .then(response=>{
                      this.modulePermissionList = response.data.modules;
                    })
                    .catch(error=>{
                      console.log(error);
                    })
                    this.$bvModal.hide('modal-top-edit-permission');
                    this.clearData();
                })
                .catch(error=>{
                  this.$notifications.notify(
                  {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
                })
              }
          })
          .catch(error=>{
              console.log(error)
          })
        },
        DeletePermission( moduleName){
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this module?', {
                title: 'Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                cancelVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                bodyClass: 'm-2',
                hideHeaderClose: false,
                centered: false
            })
          .then(value => {
              if(value === true){
                this.$store.dispatch('DeleteModuleandPermissionForUser', {userId: this.selectedUsers.id, module: moduleName})
                .then(response=>{
                    this.$notifications.notify(
                      {
                        message: `Module deleted successfully from the user.`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      })
                    this.modulePermissionList = this.modulePermissionList.filter(x=>x.name != moduleName);
                })
                .catch(error=>{
                    console.log(error);
                })
              }
          })
          .catch(error=>{
            this.$notifications.notify(
            {
              message: error.response.data,
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            })
            console.log(error)
          })
        },
        LockUser(username){
          this.$bvModal.msgBoxConfirm('Are you sure you want to lock this user?', {
                title: 'Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                cancelVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                bodyClass: 'm-2',
                hideHeaderClose: false,
                centered: false
            })
          .then(value => {
              if(value === true){
                this.$store.dispatch('LockUser', {userName: username})
                .then(response=>{
                    this.$notifications.notify(
                      {
                        message: `User locked successfully.`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      })
                    this.clearData();
                })
                .catch(error=>{
                    console.log(error);
                    this.$notifications.notify(
                    {
                      message: error.response.data,
                      horizontalAlign: 'center',
                      verticalAlign: 'top',
                      type: 'danger'
                    })
                })
              }
          })
          .catch(error=>{
              console.log(error);
          })
        },
        UnlockUser(username){
          this.$bvModal.msgBoxConfirm('Are you sure you want to unlock this user?', {
                title: 'Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'success',
                cancelVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                bodyClass: 'm-2',
                hideHeaderClose: false,
                centered: false
            })
          .then(value => {
              if(value === true){
                this.$store.dispatch('UnlockUser', {userName: username})
                .then(response=>{
                    this.$notifications.notify(
                      {
                        message: `User unlocked successfully.`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      }
                    )
                    this.clearData();
                })
                .catch(error=>{
                  console.log(error);
                  this.$notifications.notify(
                  {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
                })
              }
          })
          .catch(error=>{
              console.log(error);
          })
        },
        clearData(){
          this.moduleOptions = [];
          this.ekubTypeOptions = [];
          this.addData.username = this.addData.firstName = this.addData.lastName = this.addData.email = this.addData.phoneNumber = this.addData.role = "";
          this.$emit('AfterComplete');
        }
  
      }
  
    }
  
  </script>
  
  <style scoped>
  
    .b-table-sticky-column:last-child {
  
      right: 0;
  
    }
  
    .text-warning {
  
      color: rgba(240, 206, 13, 0.937) !important;
  
    }
  
    .btn-icon{
  
    font-size: 27px !important;
  
    padding: 3px 5px 3px 5px;
  
    width: 40px;
  
    color:  rgb(37, 91, 48);
  
    border: 2px solid rgb(37, 91, 48);
    }
  
  
  .btn-icon:hover,
  
  .btn-icon:focus {
  
    cursor: pointer;
  
    background-color: rgb(37, 91, 48) !important;
  
    color: rgba(240, 206, 13, 0.937) !important;
  
    border-radius: 4px;
  
    transition: .4s;
  }
  .table-container {
  display: flex;
  flex-direction: column;
  max-height: calc(80vh - 0px); /* Adjust depending on other UI elements */
  overflow-y: auto;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .custom-dropdown {
    max-width: 100%; /* Ensure dropdown expands on mobile */
  }

  .pagination-container {
    margin-top: 20px;
  }

  .table-container {
    max-height: 50vh; /* Lower height for better mobile usability */
  }

  .b-button-toolbar {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .b-button {
    padding: 8px;
    margin: 5px;
  }
  .table-container {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: auto;
}
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff; /* Ensure header has a background */
  z-index: 1; /* Ensure it stays on top of the table body */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
}
  
  </style>
  
   